<div *ngIf="message" [ngClass]="message.cssClass" id="alert">{{message.text}}</div>